<template>
  <div :class="MobileStyle">
    <ChatContainer></ChatContainer>
    {{MobileStyle}}
  </div>
</template>
  <script>
import ChatContainer from "../components/Main/ChatContainer.vue";
import { isMobile } from "mobile-device-detect";

// 聊天室View
export default {
  name: "ChatView",
  components: { ChatContainer },
  created() {},
  data() {
    return {};
  },
  methods: {},
  computed: {
    MobileStyle() {
    
      var version = "";
      if (this.$route.query.version != undefined) {
        version = this.$route.query.version;
      }

      if (version == 1) {
        return "isMobile";
      }
      if (version == 2) {
        return "";
      }
      if (isMobile) {
        return "isMobile";
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/ChatView.vue